import React, {useEffect, useState, useCallback} from 'react'
import * as Icon from "ubs-icons"
import {withRouter} from "react-router-dom";
import { useHistory } from "react-router-dom";
import UTags from "ubs-framework/v2/UTags";
import {COLOR} from "ubs-framework/v2/common/constant";

const ManagePlan = () => {
    const history = useHistory();

    const billingPlans = [
        {
            id: 1,
            name: "Super HRMS",
            planName: "Professional",
            nextReview: "Mon 15 Apr. 2025",
            iconKey: "hrms",
            status: "active"
        },
    ];
    const icon = useCallback((key) => {
        if (key === 'chat') return <Icon.UbsChat size={24}/>
        if (key === 'pms') return <Icon.PMS size={24}/>
        if (key === 'hrms') return <Icon.HRMS size={24}/>
        if (key === 'payroll') return <Icon.PayrollLogo size={24}/>
        if (key === 'recruit') return <Icon.ATSLogo size={24}/>
        if (key === 'assets') return <Icon.AssetsLogo size={24}/>
        if (key === 'performance') return <Icon.Performance size={24}/>
        if (key === 'survey') return <Icon.SurveyLogo size={24}/>
        if (key === 'track') return <Icon.SuperTrack size={24}/>
        if (key === 'vms') return <Icon.VMS size={24}/>
        return <Icon.Superworks size={24}/>
    }, []);

    const handle = {
        managePlan: () => {
            history?.push(`/manageplan`)
        }
    }
    return (
        <React.Fragment>
            <div className="u_layout-list u_m-0">
                <div  className={"u_flex u_flex-wrap u_p-20"}>
                    {billingPlans?.map(plan => (
                        <div key={plan.id} style={{
                            border: '1px solid #e0e0e0',
                            borderRadius: '8px',
                            width: '763px',
                            backgroundColor: 'white',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                        }}>
                            {/* Header Section */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '16px',
                            }}>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px'
                                }}>
                                    <span style={{display: 'flex', alignItems: 'center', justifyContent:"center", width:"48px", height:"48px", border:"1px solid #E2E4EC" , borderRadius:"8px"}}>{icon(plan.iconKey)}</span>
                                    <div style={{fontSize: '16px', fontWeight: 'bold', color: '#333'
                                    }}>
                                        {plan.name}
                                    </div>
                                </div>
                                <div>
                                    <UTags title='Active' className="u_ib" color={COLOR.u_green}/>
                                </div>
                            </div>
                            {/* Content Section */}
                            <div style={{
                                padding: '16px', display:"flex", justifyContent:"space-between"
                            }}>
                                <div style={{fontSize:"14px"}}>
                                    <p className={"u_pb-5"}>Plan Name</p>
                                    <p className={"u_color-title "}>{plan?.planName}</p>

                                </div>
                                <div  style={{fontSize:"14px"}}>
                                    <p className={"u_pb-5"}>Plan Start Since</p>
                                    <p className={"u_color-title "}>{plan?.nextReview}</p>
                                </div>
                                <div  style={{fontSize:"14px"}}>
                                    <p className={"u_pb-5"}>Expire On</p>
                                    <p className={"u_color-title "}>{plan?.nextReview}</p>
                                </div>
                            </div>

                            {/* Status Section */}
                            <div className={"u_p-15 u_flex-align u_content-between u_bt-light u_bg-thread"} style={{backgroundColor:"#F9FAFB"}}>
                                <div className={"u_font-16"}>
                                    <span>₹4999 / month</span>
                                </div>
                                <div>
                                    <button style={{
                                        backgroundColor: '#007bff',
                                        color: 'white',
                                        border: 'none',
                                        padding: '8px 12px',
                                        borderRadius: '4px',
                                        fontSize: '13px',
                                        cursor: 'pointer',
                                        fontWeight: '500'
                                    }}>
                                        Update Plan
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </React.Fragment>
    )
}

export default withRouter(ManagePlan)